import React, { PureComponent } from 'react'
import Groups from './groups'
import WarningMessage from './warning-message/warning-message'
import { withGroups } from '../context/groups.context'
import { withStore } from '../context/store.context'
import { getFilteredGroups } from '../store/selectors'

class GroupsContainerComponent extends PureComponent {
  render() {
    const { groups, className, selectedCategory } = this.props
    const filteredGroups = getFilteredGroups(groups, selectedCategory)
    if (!groups.length)
      return <WarningMessage>Sorry, we can't find any groups</WarningMessage>
    if (groups.length && !filteredGroups.length)
      return <WarningMessage>This category has no groups yet</WarningMessage>
    return <Groups groups={filteredGroups} className={className} />
  }
}

const GroupsContainer = withGroups(GroupsContainerComponent)

const GroupsCategoryProvider = withStore(({ store, className }) => (
  <GroupsContainer
    selectedCategory={store.selectedCategory}
    className={className}
  />
))

export default GroupsCategoryProvider
